import React, { useContext } from 'react';
import ChildHeader from 'components/Dashboard/Main/ChildHeader';
import useViewClube from './useViewClube';
import usePredefinedToastNotify from 'hooks/usePredefinedToastNotify';
import { AccountContext } from 'components/AccountContext';
import { useNavigate } from 'react-router-dom';
import PopupDependenteSemCpf from 'components/Dashboard/Main/Atendimento/PopupDependenteSemCpf';
import { Skeleton, useDisclosure } from '@chakra-ui/react';
import DrawerServico from 'components/Dashboard/Main/DrawerServico';

function DetalhesClubeVantagens() {
  const { user, toastInadimplente } = useContext(AccountContext);
  const { itensOrdenados } = useViewClube();
  const toastNotify = usePredefinedToastNotify();
  const navigate = useNavigate();
  const dataNascimento = new Date(user.data_aniv);
  const idade = user.data_aniv !== null ? new Date().getFullYear() - dataNascimento.getFullYear() : null;
  let usuario = user.id_contrato && user.descricao_plano ? true : false;
  if (user.titular === false) usuario = true;
  const disclosure_popup = useDisclosure();
  const disclosure = useDisclosure();
  const dadosPac = {
    paciente_id: user.id_cliente_deovita,
    nome: user.name,
    cpf: user.cpf,
    nascimento: user.data_aniv,
    cep: user.cep,
    code_ibge: user.codigo_ibge,
    logradouro: user.logradouro,
    numero: user.numero,
    bairro: user.bairro,
    complemento: user.complemento,
    municipio: user.municipio,
    estado: user.uf,
    celular: user.phone1 ? user.phone1 : user.phone2,
    sexo: user.sexo,
    type: 'empreendedor',
  };
  let data_parcela = '';
  if (user.qntdeParcelas?.countParcelas > 0) {
    data_parcela = user?.qntdeParcelas?.datasParcelas !== null ? new Date(user?.qntdeParcelas?.datasParcelas[0]) : null;
    if (data_parcela !== null) {
      const dia = user?.qntdeParcelas?.forma_pagamento === 13 ? 60 : 0;
      data_parcela.setDate(data_parcela?.getDate() + dia);
    }
  }

  const dataAtual = new Date();
  const isLoading = !itensOrdenados || itensOrdenados.length === 0;
  return (
    <>
      <ChildHeader page="Clube de Vantagens" />
      <PopupDependenteSemCpf disclosure={disclosure_popup} datas={dadosPac} />
      <DrawerServico disclosure={disclosure} />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          maxWidth: 600,
          margin: '0 auto',
          marginTop: 20,
          marginBottom: 20,
          paddingLeft: 12,
          paddingRight: 12,
          boxSizing: 'border-box',
        }}
      >
        {isLoading && Array.from({ length: 7 }).map((_, idx) => <Skeleton key={idx} height="120px" borderRadius="1em" mb={2} />)}
        {!isLoading &&
          itensOrdenados.length > 0 &&
          itensOrdenados.map((option, index) => {
            const svgDataUrl = `data:image/svg+xml;base64,${window.btoa(unescape(encodeURIComponent(option.svg_code)))}`;
            const svgDataUrlInterna = `data:image/svg+xml;base64,${window.btoa(unescape(encodeURIComponent(option.svg_code_interno)))}`;
            const svg_imagem_deslogado = `data:image/svg+xml;base64,${window.btoa(unescape(encodeURIComponent(option.svg_image_deslogado)))}`;

            return (
              <div
                key={index}
                style={{
                  display: 'flex',
                  width: '100%',
                  height: '140px',
                  borderRadius: '1em',
                  overflow: 'hidden',
                  backgroundColor: '#ffffff',
                  cursor: 'pointer',
                  transition: 'transform 0.2s',
                  padding: 0,
                }}
                onClick={() => {
                  if (option.ultimo) {
                    window?.ReactNativeWebView?.postMessage(
                      JSON.stringify({
                        service: true,
                        openInBrowser: true,
                        url: option.link_vantagem,
                      })
                    );
                    return;
                  }
                  if (option.destaque) {
                    if (!usuario) {
                      navigate('/mdv-nao-assinante');
                      return;
                    }
                    if (user && user.loggedIn) {
                      if (
                        ((user.titular === true && user.id_contrato > 0) || (user.titular === false && user.id_contrato === 0)) &&
                        idade !== null &&
                        idade >= 18
                      ) {
                        if (user.qntdeParcelas?.countParcelas && user.qntdeParcelas?.countParcelas > 0 && dataAtual >= data_parcela) {
                          toastInadimplente(user.id_forma_pagamento, user.qntdeParcelas);
                          return;
                        } else {
                          if (!user?.titular) {
                            toastNotify.warning('Atenção', 'Esta funcionalidade é exclusiva para o titular da assinatura');
                          } else {
                            navigate('/empreendedor');
                          }
                        }
                      } else if (user.data_aniv !== null && idade !== null && idade < 18) {
                        toastNotify.warning('Importante', 'É necessário ser maior de idade para acessar a aba de empreendedor');
                      } else if (user.data_aniv === null && idade === null) {
                        disclosure_popup.onOpen();
                      } else {
                        toastNotify.warning('Atenção', 'Ocorreu um erro inesperado. Entre em contato com o suporte');
                      }
                    } else {
                      disclosure.onOpen();
                    }
                  } else {
                    if (user.qntdeParcelas?.countParcelas && user.qntdeParcelas?.countParcelas > 0 && dataAtual >= data_parcela) {
                      toastInadimplente(user.id_forma_pagamento, user.qntdeParcelas);
                      return;
                    }
                    navigate('/descontos-ClubeVatagens', {
                      state: {
                        url_externa: option?.url_externa,
                        url_interna: svgDataUrlInterna,
                        cupom: option?.cupom,
                        link_vantagem: option?.link_vantagem,
                        descricao: option?.descricao,
                        valor_cupom: option?.valor_cupom,
                        percentual: option?.percentual,
                        nome_site: option?.nome_site,
                        botao: option?.botao,
                        titulo: option?.titulo,
                        apenas_online: option?.apenas_online,
                      },
                    });
                  }
                }}
              >
                <img
                  src={svgDataUrl}
                  alt={`Oferta ${option.nome}`}
                  style={{
                    width: '100%',
                    height: '100%',
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain',
                    objectPosition: 'center',
                    display: 'block',
                    background: '#fff',
                  }}
                />
              </div>
            );
          })}
      </div>
    </>
  );
}

export default DetalhesClubeVantagens;
